// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1121d269","977":"2caed02d"}[chunkId] + ".chunk.js";
};